module.exports = __webpack_public_path__ + "img/jq_3.535ced17.png";